import { NavLink } from "react-router";

/**
 * Fixed bottom navigation bar for mobile. Hidden on md+ breakpoints.
 * Four items: Home, Browse, Search, Create (external link to genieforge.io).
 * Mirrors the navigation structure of the desktop header.
 */
export function MobileNav() {
	return (
		<nav
			className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-surface/95 backdrop-blur-xl border-t border-border"
			style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
		>
			<div className="flex items-center justify-around h-14">
				<MobileNavLink to="/" label="Home">
					<svg
						viewBox="0 0 24 24"
						fill="none"
						stroke="currentColor"
						strokeWidth="2"
						className="h-5 w-5"
					>
						<path d="M3 9.5L12 3l9 6.5V20a1 1 0 01-1 1H4a1 1 0 01-1-1V9.5z" />
						<path d="M9 21V12h6v9" />
					</svg>
				</MobileNavLink>

				<MobileNavLink to="/browse" label="Browse">
					<svg
						viewBox="0 0 24 24"
						fill="none"
						stroke="currentColor"
						strokeWidth="2"
						className="h-5 w-5"
					>
						<rect x="3" y="3" width="7" height="7" rx="1" />
						<rect x="14" y="3" width="7" height="7" rx="1" />
						<rect x="3" y="14" width="7" height="7" rx="1" />
						<rect x="14" y="14" width="7" height="7" rx="1" />
					</svg>
				</MobileNavLink>

				<MobileNavLink to="/search" label="Search">
					<svg
						viewBox="0 0 24 24"
						fill="none"
						stroke="currentColor"
						strokeWidth="2"
						className="h-5 w-5"
					>
						<circle cx="11" cy="11" r="8" />
						<path d="m21 21-4.3-4.3" />
					</svg>
				</MobileNavLink>

				<a
					href="https://genieforge.io"
					className="flex flex-col items-center gap-0.5 text-ink-faint transition-colors"
				>
					<svg
						viewBox="0 0 24 24"
						fill="none"
						stroke="currentColor"
						strokeWidth="2"
						className="h-5 w-5"
					>
						<path d="M12 5v14M5 12h14" />
					</svg>
					<span className="text-[10px] font-medium">Create</span>
				</a>
			</div>
		</nav>
	);
}

function MobileNavLink({
	to,
	label,
	children,
}: {
	to: string;
	label: string;
	children: React.ReactNode;
}) {
	return (
		<NavLink
			to={to}
			end={to === "/"}
			className={({ isActive }) =>
				`flex flex-col items-center gap-0.5 transition-colors ${
					isActive ? "text-primary" : "text-ink-faint"
				}`
			}
		>
			{children}
			<span className="text-[10px] font-medium">{label}</span>
		</NavLink>
	);
}
